import React from 'react';

const HUBContext = React.createContext({
    //old API
    locale: 'en-US',
    theme: 'blue',
    companyID: 0,
    company: {},
    companies: [],
    sideBarItems: [],
    breadcrumbs: [],
    kpis: [],
    globalStatus: [],
    filterCatalogs: null,
    filterValues: [],
    widgetGroups: [],
    dashboards: [],
    currentDashboard: null,
    dashHandler: null,
    dragAndDropEnabled: false,
    lockWorkArea: false,
    optionsTitlePanel: [],
    expiredSession: false,
    alertNotifications: [],
    setExpiredSession: () => {},
    setLocale: () => {},
    setTheme: () => {},
    setCompanyID: () => {},
    setCompany: () => {},
    setCompanies: () => {},
    setSideBarItems: () => {},
    setBreadCrumb: () => {},
    setKpis: () => {},
    setGlobalStatus: () => {},
    setFilterCatalogs: () => {},
    setFilterValues: () => {},
    setDashboards: () => {},
    setCurrentDashboard: () => {},
    setDashHandler: () => {},
    setCurrentDashboardWidgetSort: () => {},
    setDragAndDropEnabled: () => {},
    setOptionsTitlePanel:() =>{},
    setRestoreOriginalLayOut: () => {},
    setAlertNotifications: () => {},

    //New API
    filters:[],
    globalFilter:[],
    pivotglobalFilter: '',
    dashboardWidgetsGroups: [],
    customLayout: false,
    restoreOriginalLayOut: null,
    
    setFilters: () => {},
    setGlobalFilter: () => {},
    setPivotGlobalFilter: () => {},
    setDashboardWidgetsGroups: () => {},
    setCustomLayout: () => {},
});

export default HUBContext;